import { render, staticRenderFns } from "./ParticipantesChart.vue?vue&type=template&id=4a329976"
import script from "./ParticipantesChart.vue?vue&type=script&lang=js"
export * from "./ParticipantesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports